import VatService from './VatService.container';

export default VatService;
